import mixpanel from "mixpanel-browser"

export enum PRODUCT_TOUR_EVENTS {
  START = "Student started product tour",
  SKIP = "Student skipped product tour",
  END = "Student completed product tour",
  // Product tour v2
  START_FIRST_VIDEO = "Student started first video on study page",
  START_SECOND_VIDEO = "Student started second video on my situation page",
  PRESS_CONTINUE_STUDYING = "Student pressed continue studying",
}

export interface CommonProps {
  email: string
  name: string
  organization: string
}

export type WithSkippedStep<T extends string> = CommonProps & {
  [key in T]: string
}

export function trackEvent(
  event: PRODUCT_TOUR_EVENTS,
  props: CommonProps | WithSkippedStep<string>,
) {
  mixpanel.track(event, { ...props, organization: props.organization || "Siglo 21" })
}

const productTourEvents = {
  start: (props: CommonProps) => trackEvent(PRODUCT_TOUR_EVENTS.START, props),
  skip: (props: CommonProps | WithSkippedStep<string>) =>
    trackEvent(PRODUCT_TOUR_EVENTS.SKIP, props),
  end: (props: CommonProps) => trackEvent(PRODUCT_TOUR_EVENTS.END, props),
  // Product tour v2
  startFirstVideo: (props: CommonProps) => trackEvent(PRODUCT_TOUR_EVENTS.START_FIRST_VIDEO, props),
  startSecondVideo: (props: CommonProps) =>
    trackEvent(PRODUCT_TOUR_EVENTS.START_SECOND_VIDEO, props),
  pressContinueStudying: (props: CommonProps) =>
    trackEvent(PRODUCT_TOUR_EVENTS.PRESS_CONTINUE_STUDYING, props),
}

export default productTourEvents
